module.exports = __webpack_public_path__ + "static/media/bell.43ee4821.svg";